import { render, staticRenderFns } from "./filtriCategoriePage.vue?vue&type=template&id=377954ac&"
import script from "./filtriCategoriePage.vue.ts?vue&type=script&lang=ts&"
export * from "./filtriCategoriePage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports